import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalRHQUserAddDialog } from './ModalRHQUserAddDialog'
import { ModalUserAddDialog } from './ModalUserAddDialog'

type UserAddButtonProps = {
  children: ReactNode
  title: string
  onAdd: (
    rhq: string,
    salesCompany: string,
    loginId: string,
    password: string,
    role: number,
  ) => void
}

export const UserAddButton: React.FC<UserAddButtonProps> = props => {
  const { onAdd } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [rhq, setRhq] = useState('')
  const [salesCompany, setSalesCompany] = useState('')
  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [role, setRole] = useState(0)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = (args: {
    loginId: string
    password: string
    rhq?: string
    salesCompany?: string
    role: number
  }) => {
    const { loginId, password, rhq, salesCompany, role } = args
    // console.log("handleSave");
    rhq ? setRhq(rhq) : setRhq(auth.rhq)
    salesCompany && setSalesCompany(salesCompany)
    setLoginId(loginId)
    setPassword(password)
    setRole(role)
    handleClose()
  }

  const onClickHandler = async () => {
    handleOpen()
  }
  useEffect(() => {
    if ((rhq !== '' || salesCompany !== '') && loginId !== '' && password !== '' && role !== 0) {
      // console.log(`rhq:${rhq} salesCompany:${salesCompany} loginId:${loginId} password:${password} role:${role}`);
      onAdd(rhq, salesCompany, loginId, password, role)
      setSalesCompany('')
      setLoginId('')
      setPassword('')
      setRole(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rhq, salesCompany, loginId, password, role])
  //多言語化対応
  const userLanguage = navigator.language || navigator.languages[0]
  const baseLanguage = userLanguage.split('-')[0]
  let userAddButtonJsx: JSX.Element
  switch (baseLanguage) {
    case 'de':
    case 'sv':
      userAddButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={onClickHandler}
          startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
          sx={{
            justifyContent: 'center',
            alignContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/32px Noto Sans JP',
            paddingTop: '6px',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '80px',
            width: '250px',
            borderRadius: '40px',
            '& .MuiSvgIcon-root': {
              fontSize: '32px',
            },
          }}
        >
          {props.children}
        </Button>
      )
      break
    default:
      userAddButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={onClickHandler}
          startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
          sx={{
            justifyContent: 'center',
            alignContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/32px Noto Sans JP',
            paddingTop: '6px',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '80px',
            width: '200px',
            borderRadius: '40px',
            '& .MuiSvgIcon-root': {
              fontSize: '32px',
            },
          }}
        >
          {props.children}
        </Button>
      )
      break
  }
  return (
    <>
      {open &&
        (auth.role === 0 ? (
          <ModalRHQUserAddDialog
            open={open}
            title={props.title}
            onClose={handleClose}
            onSave={handleSave}
          />
        ) : (
          <ModalUserAddDialog
            open={open}
            title={props.title}
            onClose={handleClose}
            onSave={handleSave}
          />
        ))}
      {userAddButtonJsx}
    </>
  )
}
